<template>
    <div class="game-tag-manageable">
        <span class="hidden-xs-only">
            <el-select v-model="game.status.labels"
                       placeholder="no status"
                       :class="`tag-style-${game.status.labels[0]} clickable`"
                       multiple
                       :loading="!!game.updatingStatus"
                       @change="addStatus(game)">
                <el-option
                        v-for="item in manageOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    <el-tag :type="item.type" size="mini">
                        <i :class="item.icon"></i>
                        {{item.label}}
                    </el-tag>
                </el-option>
            </el-select>
        </span>

        <span class="hidden-sm-and-up">
            <el-select v-model="game.status.labels"
                       placeholder="no status"
                       :class="`${classIcons[game.status.labels[0]] || 'el-icon-bell'} tag-style-${game.status.labels[0]} clickable`"
                       multiple
                       :loading="!!game.updatingStatus"
                       @change="addStatus(game)">
                    <el-option
                            v-for="item in manageOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <el-tag :type="item.type" size="mini">
                            <i :class="item.icon"></i>
                            {{item.label}}
                        </el-tag>
                    </el-option>
                </el-select>
        </span>

    </div>
</template>

<script>
export default {
  name: 'gameTagManageable',
  components: {},
  props: ['game', 'addStatus'],
  mounted () {},
  data () {
    return {
      classIcons: {
        'going2play': 'el-icon-circle-plus',
        'playing': 'el-icon-caret-right',
        'paused': 'el-icon-video-pause',
        'played': 'el-icon-remove',
        'finished': 'el-icon-success',
        'none': 'el-icon-bell'
      },

      manageOptions: [{
        icon: 'el-icon-circle-plus',
        type: 'warning',
        value: 'going2play',
        label: 'Going to play'
      }, {
        icon: 'el-icon-caret-right',
        type: '',
        value: 'playing',
        label: 'Playing'
      }, {
        icon: 'el-icon-video-pause',
        type: 'warning',
        value: 'paused',
        label: 'Pause'
      }, {
        icon: 'el-icon-remove',
        type: '',
        value: 'played',
        label: 'Played'
      }, {
        icon: 'el-icon-success',
        type: 'success',
        value: 'finished',
        label: 'Finished'
      }, {
        icon: 'el-icon-error',
        type: 'danger',
        value: 'clear',
        label: 'Clear'
      }, {
        icon: 'el-icon-delete-solid',
        type: 'danger',
        value: 'remove',
        label: 'Remove'
      }]
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.game-tag-manageable {
    .el-select.tag-style-none {
        .el-tag.el-tag--info {
            color: gray;
            background-color: #fffdfb;
            border-color: gray;
            margin-left: 24px ;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-select.tag-style-going2play {
        .el-tag.el-tag--info {
            color: orange;
            background-color: #fffbf0;
            border-color: orange;
            margin-left: 0px ;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-select.tag-style-playing {
        .el-tag.el-tag--info {
            color: blue;
            background-color: #f6fffd;
            border-color: blue;
            margin-left: 20px ;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-select.tag-style-paused {
        .el-tag.el-tag--info {
            color: purple;
            background-color: #fff1f3;
            border-color: purple;
            margin-left: 25px;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-select.tag-style-played {
        .el-tag.el-tag--info {
            color: orange;
            background-color: #fffbf0;
            border-color: orange;
            margin-left: 21px;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-select.tag-style-finished {
        .el-tag.el-tag--info {
            color: green;
            background-color: #f8fff7;
            border-color: green;
            margin-left: 16px;

            .el-tag__close {
                display: none;
            }
        }
    }

    .el-input__inner {
        background-color: transparent;
    }

    margin-bottom: -10px;
    margin-top: -5px;

    .el-input__inner {
        border-width: 0px;
    }

    .el-input__suffix {
        visibility: hidden;
    }

    .el-select::before{
        visibility: hidden;
    }

    @media screen and (max-width: 35em) {
        width: 45px;
        overflow: hidden;
        margin-top: -15px;

        .el-select__tags-text {
            visibility: hidden;
        }

        .el-select::before{
            color: gray;
            position: absolute;
            margin-top: 12px;
            margin-left: -18px !important;
            z-index: 10;
            visibility: visible;
        }

        .tag-style-played::before{
            color: orange !important;
        }
        .tag-style-finished::before{
            color: green !important;
        }
        .tag-style-paused::before{
            color: purple !important;
        }
        .tag-style-playing::before{
            color: blue !important;
        }
        .tag-style-none::before{
            color: gray !important;
        }
        .tag-style-going2play::before{
            color: orange !important;
        }

        .el-tag.el-tag--info.el-tag--small.el-tag--light {
            width: 25px;
            margin-left: 0px !important;
        }
    }

}
</style>
